import { Component, Input, ViewChild, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CustomQualification } from 'src/app/models/custom-qualification';
import { MasterQualification } from 'src/app/models/master-qualification';
import { RequestTypeQualification } from 'src/app/models/requesttypequalification';
import { ServiceDef } from 'src/app/models/service-def';
import { ServiceQualification } from 'src/app/models/service-qualification';
import { QualificationService } from 'src/app/services/qualifications.service';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { CDK_DRAG_CONFIG, CdkDragDrop, CdkDragStart, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkColumnDef } from '@angular/cdk/table';
import { ElementRef } from '@angular/core';
import { DataRecord } from "../../../../requests/commands/req-status/req-status.component";
import { HouseholdMember } from 'src/app/models/household-member';
import { MemberDto } from 'src/app/models/member-dto';
import { MatSort } from '@angular/material/sort';
import { CasesService } from 'src/app/services/cases.service';
import {
	ConfirmDialogComponent,
	ConfirmDialogModel
} from '../../../../../components/shared/confirmation-dialog/confirmation-dialog.component';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DwUtils } from 'src/app/components/utils/dw-utils';

const DragConfig = {
	dragStartThreshold: 0,
	pointerDirectionChangeThreshold: 5,
	zIndex: 10000
};

@Component({
	selector: 'app-duplicate-members-dlg',
	templateUrl: './duplicate-members-dlg.component.html',
	styleUrls: ['./duplicate-members-dlg.component.css'],
})
export class DuplicateMembersDlgComponent {

	strErr = '';
	result: any;
	public selectedRecord: HouseholdMember;
	public primaryRecord: MemberDto;
	public Idx: number | null = -1;
	public primaryMemberRows: any;
	selectedMembers: any;
	public records: HouseholdMember[];
	public dataSource1: MatTableDataSource<any>;
	public dataSource2: MatTableDataSource<HouseholdMember>;
	public renderedData: Array<any>;
	public displayedColumns1: string[] = ['label'];
	public displayedColumns2: string[] = ['select', 'id', 'firstName', 'middleName', 'lastName', 'dateOfBirth', 'gender', 'dateAdded', 'memberComments'];
	public busyCursor: boolean = false;
	selectedOption = '';
	disableMoveLeftBtn = true;
	disableMoveRightBtn = true;
	disableBypassBtn = false;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	duplicateKey: string;

	@Output() membersChanged = new EventEmitter();
	@Output() submitClicked = new EventEmitter();
	@Output() cancelClicked = new EventEmitter();


	constructor(private casesService: CasesService, public dialog: MatDialog) {

	}

	public ngOnInit() {
		this.selectedMembers = [];
	}


	public onShowHandler(member: MemberDto) {
		this.strErr = '';
		this.primaryRecord = member;
		this.queryRecords();
		this.primaryMemberRows = [];
		if (!this.primaryRecord.memberComments) {
			this.primaryRecord.memberComments = '';
		}
		if (!this.primaryRecord.middleName) {
			this.primaryRecord.middleName = '';
		}
		this.primaryMemberRows.push({ label: 'Id: ' + this.primaryRecord.memberId });
		this.primaryMemberRows.push({ label: 'Name: ' + this.primaryRecord.firstName + ' ' + this.primaryRecord.middleName + ' ' + this.primaryRecord.lastName });
		if (this.primaryRecord['relationship'] === 'Advocate') {
			this.primaryMemberRows.push({ label: 'DOB:' });
			this.primaryMemberRows.push({ label: 'Gender:' });

		} else {
			this.primaryMemberRows.push({ label: 'DOB: ' + Settings.getInstance().formatDate(this.primaryRecord.dateOfBirth) });
			this.primaryMemberRows.push({ label: 'Gender: ' + this.primaryRecord.gender });

		}
		this.primaryMemberRows.push({ label: 'Date added: ' + Settings.getInstance().formatDate(this.primaryRecord.dateAdded) });

		this.primaryMemberRows.push({ label: 'Comments: ' + this.primaryRecord.memberComments });
		this.dataSource1 = new MatTableDataSource(this.primaryMemberRows);
	}

	queryRecords() {
		this.busyCursor = true;
		this.casesService.getAllDuplicateMembers(this.primaryRecord.duplicateKey, this.primaryRecord.memberId).subscribe(
			(result) => {
				this.records = result;
				this.dataSource2 = new MatTableDataSource(this.records);
				this.dataSource2.sort = this.sort;
				this.busyCursor = false;
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve duplicate member details from the server');
				this.busyCursor = false;
			}
		);
	}
	public doCheckUnCheck(val: any): void {

		/** check to see if any records are selected **/
		const numSelected =
			this.dataSource2.data.filter(s => s.isSelected === true).length;

		if (numSelected > 0) {
			this.disableMoveRightBtn = false;
			this.disableMoveLeftBtn = false;
		}
		else {
			this.disableMoveRightBtn = true;
			this.disableMoveLeftBtn = true;
		}
	}
	getFormattedMemberName(primaryRecord: any): string {
		if (!primaryRecord) {
			return '';
		}
		const { firstName, middleName, lastName } = primaryRecord;
		return `${(firstName || '') + ' ' + (middleName || '') + ' ' + (lastName || '')}`.trim();
	}
	handleFirstOption() {
		this.strErr = '';
		console.log(this.disableMoveLeftBtn);
		this.selectedMembers = this.records.filter(member => member.isSelected === true || member.isSelected === 1);
		if (this.selectedMembers.length > 1) {
			this.strErr = 'Only one record from table can be selected';
			return;
		}
		if (!this.selectedMembers || this.selectedMembers.length === 0) {
			this.strErr = 'Please select one record from table';
			return;
		}

		const message = 'WARNING: This will replace the member record on the right, with a selected similar member (on the left).  This cannot be undone. Are You Sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '500px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.casesService.replaceCaseMemberWithAnotherMember(this.primaryRecord.memberId, this.selectedMembers[0].id, this.primaryRecord.caseId).subscribe(
					(result) => {
						this.submitClicked.emit({ resolvedStatus: null });
					},
					(error) => {
						Settings.getInstance().handleError('Error: unable to update duplicate status');
					}
				);
			}
		});

	}
	handleSecondOption() {
		this.strErr = '';
		this.selectedMembers = this.records.filter(member => member.isSelected === true || member.isSelected === 1);
		const selectedMemberIds = this.selectedMembers.map(member => member.id);
		if (!this.selectedMembers || this.selectedMembers.length === 0) {
			this.strErr = 'Please select at least one record from table';
			return;
		}
		const message = 'WARNING: This will replace the selected similar member(s) with the member record to the right.  This cannot be undone. Are You Sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '500px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.casesService.replaceMatchingMembersWithDominantMemberRecord(selectedMemberIds, this.primaryRecord.memberId).subscribe(
					(result) => {
						this.submitClicked.emit({ resolvedStatus: null });
					},
					(error) => {
						Settings.getInstance().handleError('Error: unable to update duplicate status');
					}
				);
			}
		});
	}
	handleThirdOption() {
		this.strErr = '';
		const message = 'This will acknowledge that the two records (member and selected similar member) are in fact different people. This will mark the duplication as resolved. Are you Sure?';
		const dialogData = new ConfirmDialogModel('Please Confirm', message);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '500px',
			data: dialogData,
			panelClass: 'custom-dialog-container'
		});

		dialogRef.afterClosed().subscribe(dialogResult => {
			this.result = dialogResult;
			if (this.result === true) {
				this.casesService.updateDuplicateStatusForMember(this.primaryRecord.memberId, null).subscribe(
					(result1) => {
						this.submitClicked.emit({ resolvedStatus: 'R' });
					},
					(error1) => {
						Settings.getInstance().handleError('Error: unable to update duplicate status');
					}
				);
			}
		});
	}
	cancelSubmitRecord() {
		this.cancelClicked.emit();
	}

	setDisableFlags() {
		this.selectedMembers = this.records.filter(member => member.isSelected === true || member.isSelected === 1);
		if (!this.selectedMembers || this.selectedMembers.length > 1) {
			this.disableMoveLeftBtn = true;

		} else {
			this.disableMoveLeftBtn = false;
		}
	}
	public lblShowDate(inp: string): string {

		const ret = DwUtils.formatReadableStringNoDay(inp);
		return ret;
	}
}
